'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isThisWeek;


// WEBPACK FOOTER //
// ./~/sugar-date/date/isThisWeek.js